export default __webpack_public_path__ + "static/media/knacklab-cvs-sample.b65fb287.csv";